// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YpJz","field":"styles_field__3lqdD","fieldCol":"styles_fieldCol__1t1mJ","diffCol":"styles_diffCol__1ogxL","diff":"styles_diff__2Z8Ua"};